module.exports = __webpack_public_path__ + "7bb0c53d8cc652a35f2f381d9ebaf2b7.svg";